import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { DocumentTypesEnum } from '../../../document-data/document-data.data';
import { CalculationResult } from '../../../document-data/sub-models/calculation-result.model';

@Component({
  selector: 'app-document-balance-breakdown',
  templateUrl: './document-balance-breakdown.component.html',
  styleUrls: ['./document-balance-breakdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentBalanceBreakdownComponent implements OnInit {
  @Input() documentCalculationResult: CalculationResult;
  @Input() currencyCode: string;
  @Input() locale: string;
  @Input() documentType: DocumentTypesEnum;
  @Input() showTotal: boolean;
  @Input() showPaid: boolean;
  @Input() useOutstandingBalance: boolean;

  constructor() {}

  ngOnInit() {}
}
